import { useRef, useState } from "react";
import { Camera, ImageIcon, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { uploadImage, fileUrl, formatApiError } from "@/lib/api";
import { CameraDialog } from "@/components/CameraDialog";

export function IdDocSlot({ label, path, onPath, testid }) {
  const [camOpen, setCamOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const galleryRef = useRef(null);
  const upload = async (blob) => {
    setBusy(true);
    try { onPath(await uploadImage(blob, `documento_${testid}.jpg`, "sensitive")); } catch (err) { toast.error(formatApiError(err)); throw err; } finally { setBusy(false); }
  };
  const onFile = async (e) => {
    const f = e.target.files?.[0];
    e.target.value = "";
    if (f) await upload(f).catch(() => {});
  };
  return (
    <div className="rounded-xl border border-[var(--border)] p-3 space-y-2" data-testid={`id-slot-${testid}`}>
      <p className="text-sm font-semibold">{label}</p>
      {path
        ? <img src={fileUrl(path)} alt={label} className="rounded-lg border w-full h-36 object-contain bg-[var(--surface-2)]" data-testid={`id-preview-${testid}`} />
        : <div className="rounded-lg border border-dashed h-36 grid place-items-center text-xs text-[var(--muted)]">{busy ? <Loader2 className="h-5 w-5 animate-spin" /> : "Nessuna foto"}</div>}
      <div className="grid grid-cols-2 gap-2">
        <button type="button" onClick={() => setCamOpen(true)} disabled={busy} className="btn-primary h-10 px-3 text-sm" data-testid={`id-camera-${testid}`}><Camera className="h-4 w-4" /> {path ? "Rifai" : "Scatta"}</button>
        <button type="button" onClick={() => galleryRef.current.click()} disabled={busy} className="btn-secondary h-10 px-3 text-sm" data-testid={`id-gallery-${testid}`}><ImageIcon className="h-4 w-4" /> Galleria</button>
      </div>
      <input ref={galleryRef} type="file" accept="image/*" className="hidden" onChange={onFile} data-testid={`id-file-${testid}`} />
      <CameraDialog open={camOpen} onOpenChange={setCamOpen} title={`Foto documento – ${label.toLowerCase()}`} onCapture={upload} />
    </div>
  );
}
